import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * Fetch TAT (Turnaround Time) list with pagination and search.
 * POST api/Onboarding/tat-list
 *
 * @param {Object} params
 * @param {string} [params.searchValue] - Search by entity name / ID
 * @param {number} [params.pageNo]      - Page number (default: 1)
 * @param {number} [params.pageSize]    - Page size (default: 10)
 */
export const fetchTatListAction = async ({
  searchValue = "",
  pageNo = 1,
  pageSize = 10,
} = {}) => {
  try {
    const body = {
      searchValue: searchValue || null,
      pageNo,
      pageSize,
    };

    const response = await apiClient.post(ATP_API_URL.TAT_LIST, body);

    if (response?.status === 200 && response.data) {
      const { success, result } = response.data;

      if (success && result) {
        return {
          success: true,
          data: result.tatlogs || [],
          totalCount: result.totalRecords || 0,
          totalPages: result.totalPages || 1,
          currentPage: result.currentPage || pageNo,
        };
      }
    }

    return {
      success: false,
      message: "Failed to fetch TAT list",
      data: [],
      totalCount: 0,
      totalPages: 1,
    };
  } catch (error) {
    console.error("[TATList] error:", error);
    return {
      success: false,
      message: error.message || "Failed to fetch TAT list",
      data: [],
      totalCount: 0,
      totalPages: 1,
    };
  }
};
